import classNames from "classnames";
import { Loading, OfferItemInfo, OfferPriceInfo } from "components";
import messages from "i18n/messages";
import first from "lodash/first";
import filter from "lodash/filter";
import flowRight from "lodash/flowRight";
import {
  claimOffer,
  makeSelectPriceNames,
  makeSelectBookingType,
  makeSelectQty,
} from "logic/orders";
import { makeSelectPcts } from "logic/pcts";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";

class PriceItem extends Component {
  static propTypes = {
    date: PropTypes.object.isRequired,
  };

  handleBook = () =>
    !this.isDisabled()
      ? this.props.actions.claimOffer(this.props.offer, true)
      : null;

  bookOrReserveText = (bookingType) =>
    bookingType === "res" ? "reserve" : "book";

  isDisabled = () => this.props.offer.disabled || this.props.qty < 1;

  renderPriceValueCol = (offer, bookingType, addFees, mobile = false) => (
    <div
      className={classNames("price-value-col", {
        "d-block d-sm-none": mobile,
        "d-none d-sm-block": !mobile,
      })}
    >
      <OfferPriceInfo offer={offer} />
      {bookingType === "buy" && addFees ? (
        <FormattedMessage {...messages.voucherAdditionalFeesMayApply} />
      ) : null}
    </div>
  );

  render() {
    const { pct, bookingType, offer, priceNames, date, pcts } = this.props;
    const { formatMessage: f } = this.props.intl;
    const { loading } = offer;
    if (offer.seat_ids.length < 1) return <></>;

    const prices = filter(pct.prices, (price) =>
      priceNames.includes(price.name)
    );
    if (!prices) return <></>;

    const addFees =
      first(prices) &&
      first(prices).fees &&
      (first(prices).fees.cr || first(prices).fees.sr);

    return (
      <div className="price-item">
        <div className="price-name-col">
          <div className="pct-info">
            {pcts && Object.keys(pcts).length > 1 ? (
              <div
                className="pct-color"
                style={{ backgroundColor: pct.color }}
              ></div>
            ) : null}
            <div>
              {pcts && Object.keys(pcts).length < 2
                ? f(messages.total)
                : pct.name}
            </div>
            {this.renderPriceValueCol(offer, bookingType, addFees, true)}
          </div>
          <OfferItemInfo offer={offer} date={date} />
        </div>
        {this.renderPriceValueCol(offer, bookingType, addFees)}
        <div
          className={classNames("book-btn btn btn-primary", {
            loading,
            disabled: this.isDisabled(),
          })}
          onClick={this.handleBook}
        >
          {loading ? (
            <Loading color="white" width="1.5em" />
          ) : (
            <FormattedMessage
              {...messages[this.bookOrReserveText(bookingType)]}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  priceNames: makeSelectPriceNames(),
  pcts: makeSelectPcts(),
  qty: makeSelectQty(),
  bookingType: makeSelectBookingType(),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      claimOffer,
    },
    dispatch
  ),
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
);

export default enhance(PriceItem);
